import { Avatar, Skeleton } from '@mui/material'
import { FC } from 'react'

import { Campaign } from '@/clients/utoniq-core/schema'

export type CampaignRankImageProps = {
  loading?: boolean
  height?: number
  thumbnail: Campaign['thumbnail']
}

export const CampaignRankImage: FC<CampaignRankImageProps> = ({
  loading,
  height = 212,
  thumbnail,
}) => {
  if (loading) {
    return <Skeleton variant="rectangular" sx={{ width: '100%', height }} />
  }
  return (
    <Avatar
      variant="square"
      src={thumbnail?.smallUri ?? thumbnail?.uri ?? ''}
      sx={{ width: '100%', height }}
    />
  )
}
